import { AbstractEthereumConnector, } from "@renproject/multiwallet-abstract-ethereum-connector";
const isResults = (x) => x.results !== undefined;
const resultOrRaw = (x) => {
    if (isResults(x)) {
        return x.results;
    }
    return x;
};
export class EthereumInjectedConnector extends AbstractEthereumConnector {
    constructor(options) {
        super(options);
        this.supportsTestnet = true;
        this.handleUpdate = () => {
            this.getStatus()
                .then((...args) => {
                this.emitter.emitUpdate(...args);
            })
                .catch(async (...args) => this.deactivate(...args));
        };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.activate = async () => {
            // Await in case a child class's getProvider is asynchronous.
            const provider = await this.getProvider();
            if (!provider) {
                throw Error("Missing Provider");
            }
            // clear all previous listeners
            await this.cleanup();
            if (provider.isMetamask) {
                // This behavior is being deprecated so don't rely on it
                provider.autoRefreshOnNetworkChange = false;
            }
            let account;
            try {
                account = resultOrRaw(await provider.request({ method: "eth_requestAccounts" }))[0];
            }
            catch (error) {
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                if (error.code === 4001) {
                    this.emitter.emitError(new Error("User rejected request"));
                }
                console.error(error);
            }
            // if unsuccessful, try enable
            if (!account) {
                account = resultOrRaw(await provider.enable())[0];
            }
            provider.on("close", this.deactivate);
            provider.on("networkChanged", this.handleUpdate);
            provider.on("accountsChanged", this.handleUpdate);
            provider.on("chainChanged", this.handleUpdate);
            return this.getStatus();
        };
        this.getProvider = () => {
            return window.ethereum;
        };
        this.cleanup = async () => {
            // Await in case a child class's getProvider is asynchronous.
            const provider = await this.getProvider();
            if (provider.removeListener) {
                // eslint-disable-next-line @typescript-eslint/no-misused-promises
                provider.removeListener("close", this.deactivate);
                provider.removeListener("networkChanged", this.handleUpdate);
                provider.removeListener("accountsChanged", this.handleUpdate);
                provider.removeListener("chainChanged", this.handleUpdate);
            }
        };
        this.deactivate = async (reason) => {
            await this.cleanup();
            this.emitter.emitDeactivate(reason);
        };
    }
}
